import { Row } from "antd";
import { LowerMenuBar } from "../../pages/calendar/lower-menu-bar/lower-menu-bat";
import { StyledFooter } from "./footer.style";

export const Footer = () => {
  return (


    <StyledFooter href="https://libmogilev.by/" target="_blank">
      <img
        src={`${process.env.PUBLIC_URL}/assets/images/mogilev-library-icon.png`}
        alt="logo"
      />
      <p>
        Установа культуры &laquo;Магілёўская абласная бібліятэка ім. У. І. Леніна&raquo;
      </p>
    </StyledFooter>
  );
};
